import React, {useEffect, useState} from "react";
import {Redirect} from "react-router-dom";
import {connect, useDispatch, useSelector} from "react-redux";
import {
    FINDTIRES,
    MAKE,
    MODEL,
    required,
    TIRESIZE,
    TRIM,
    YEAR,
    ZIP_ERROR
} from "../../shared/constantsEN";
import FormControl from "@material-ui/core/FormControl";
import {Dialog, FormHelperText, IconButton, InputLabel, MenuItem, Select, TextField} from "@material-ui/core";
import yearMakeModelService from "../../shared/services/yearMakeModelService";
import {
    clearCurrentLatLng,
    setFilteredResult,
    setMakes,
    setModels,
    setSearchResult,
    setSelectMake,
    setSelectModel,
    setSelectSize,
    setSelectTrim,
    setSelectYear,
    setSizes,
    setTrims,
    setZipCode,
    updateResults
} from "../../core/redux/ActionCreator";
import Grid from "@material-ui/core/Grid";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import sizeImage from "../../shared/images/_TireSize_PopUp.jpg";
import sizeImage_chevy from "../../shared/images/_chevyTireSize_PopUp.jpg";
import Analytics from "../../shared/util/analytics";

function Widget ({ makes, models,trims, sizes, years}) {

    const[errZip, setErrZip] = useState(false);
    const[isValid] = useState(false);
    const[make, setMake] = useState('');
    const[makeError, setMakeError] = useState(false);
    const[model, setModel] = useState('');
    const[modelError, setModelError] = useState(false);
    const[size, setSize] = useState('');
    const[sizeError, setSizeError] = useState(false);
    const [trim, setTrim] = useState('');
    const [year, setYear] = useState('');
    const [yearError, setYearError] = useState(false);
    const [zip, setZip] = useState('');
    const [zipError, setZipError] = useState(false);
    const analytics = Analytics();
    const brand = useSelector(state => state.appParamsReducer.brand)
    const clearData = [];
    const dispatch = useDispatch();
    const resultsUpdated = useSelector(state => state.searchResultReducer.updateResult);
    const server = useSelector(state => state.appParamsReducer.loadingServer);useEffect(() => {
        analytics.trackPage('find-tire-widget')
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (resultsUpdated) {
            dispatch(setSearchResult([]));
            dispatch(updateResults({updateResult: false}));
            dispatch(setFilteredResult([]));
        }
    }, [resultsUpdated, dispatch]);

    useEffect(function getYears() {
        if(years.length === 0) yearMakeModelService.getYears();
        if(year !== '' && makes.length === 0)        yearMakeModelService.getMakes(year);
        if(year !== '' && make !== '' && models.length === 0) yearMakeModelService.getModels(year,make);
        if(year !== '' && make !== '' && model !== '' && trims.length === 0){
            yearMakeModelService.getTrims(year,make,model);
            yearMakeModelService.getSizes(year,make,model,null);
        }
        if(year !== '' && make !== '' && model !== '' && sizes.length === 0) {
            yearMakeModelService.getSizes(year,make,model,trim);
        }
    })

    useEffect(()=>{
        if(sizes.length ===1 && size === ''){
            setSize(sizes[0]);
            dispatch(setSelectSize(sizes[0]));
        }
        // eslint-disable-next-line
    },[sizes])

    if (isValid) return <Redirect to="/dealerLocator"/>

    function ValidateAndLoad(path) {
        if (year !== '' && make !== '' && model !== '' && size !== ''
            && (path === 'zip' ? zip.match(/^\b\d{5}(-\d{4})?\b$/) : true)) {
            let newUrl = server + '?year=' + year + '&make=' + make +
                '&model=' + model + '&size=' + size.replace('/', '_') + '&zip=' + zip;
            if(brand) newUrl+='&src='+brand;
            window.open(newUrl, '_blank', 'noopener,noreferrer')
        }else {
            if (year === '') setYearError(true);
            if (make === '') setMakeError(true);
            if (model === '') setModelError(true);
            if (size === '') setSizeError(true);
            if (zip === '') setZipError(true);
        }
    }

    const yearDropdown = (
        <FormControl size={'small'} margin="dense" variant="outlined">
            <InputLabel className="dropdownLabel" htmlFor="year-dropdown-label">
                {YEAR}
            </InputLabel>
            <Select
                className="year-dropdown"
                label={YEAR}
                labelId="year-dropdown-label"
                onChange={handleChangeYear}
                onClose={handleCloseYear}
                value={year}
                inputProps={{
                    "class": `MuiSelect-nativeInput stat-dropdown`,
                    "data-dtm": "vehicle info"
                }}
                required
            >
                {years.map(item => (<MenuItem className="dropdown-group-element" key={item} value={item}>{item}</MenuItem>))}
            </Select>
            {yearError && (<FormHelperText error>{required}</FormHelperText>)}
        </FormControl>
    );

    const makeDropdown = (
        <FormControl size={'small'} margin="dense" variant="outlined">
            <InputLabel
                className="make-dropdown-label"
                disabled={!year}
                htmlFor="make-dropdown-label"
            >
                {MAKE}
            </InputLabel>
            <Select
                className="make-dropdown"
                label={MAKE}
                labelId="make-dropdown-label"
                onChange={handleChangeMake}
                onClose={handleCloseMake}
                value={make}
                inputProps={{
                    "class": `MuiSelect-nativeInput stat-dropdown`,
                    "data-dtm": "vehicle info"
                }}
                disabled={!year}
                required
            >
                {makes.map(item => (
                    <MenuItem className="dropdown-group-element" key={item} value={item}>
                        {item}
                    </MenuItem>))}
            </Select>
            {makeError && (<FormHelperText error>{required}</FormHelperText>)}
        </FormControl>
    );

    const modelDropdown = (
        <FormControl size={'small'} margin="dense" variant="outlined">
            <InputLabel
                className="model-dropdown-label"
                disabled={!make}
                htmlFor="model-dropdown-label"
            >
                {MODEL}
            </InputLabel>
            <Select
                className="model-dropdown"
                label={MODEL}
                labelId="model-dropdown-label"
                onChange={handleChangeModel}
                onClose={handleCloseModel}
                value={model}
                disabled={!make}
                inputProps={{
                    "class": `MuiSelect-nativeInput stat-dropdown`,
                    "data-dtm": "vehicle info"
                }}
                required
            >
                {models.map(item => (
                    <MenuItem className="dropdown-group-element" key={item} value={item}>
                        {item}
                    </MenuItem>))}
            </Select>
            {modelError && (
                <FormHelperText error>{required}</FormHelperText>
            )}
        </FormControl>
    );

    const trimDropdown = (
        <FormControl size={'small'} margin="dense" variant="outlined">
            <InputLabel
                className="trim-dropdown-label"
                disabled={!model}
                htmlFor="model-dropdown-label"
            >
                {TRIM}
            </InputLabel>
            <Select
                className="trim-dropdown"
                label={TRIM}
                labelId="model-dropdown-label"
                onChange={handleChangeTrim}
                value={trim}
                disabled={!model}
                inputProps={{
                    "class": `MuiSelect-nativeInput stat-dropdown`,
                    "data-dtm": "vehicle info"
                }}
            >
                {trims.map((item) => (
                    <MenuItem className="dropdown-group-element" key={item} value={item}>
                        {item}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );

    const sizeDropdown = (
        <FormControl size={'small'} margin="dense" variant="outlined">
            <InputLabel
                className="trim-dropdown-label"
                disabled={!model}
                htmlFor="model-dropdown-label"
            >
                {TIRESIZE}
            </InputLabel>
            <Select
                className="trim-dropdown"
                label={TIRESIZE}
                labelId="size-dropdown-label"
                onChange={handleChangeSize}
                onClose={handleCloseSize}
                value={size}
                disabled={!model}
                inputProps={{
                    "class": `MuiSelect-nativeInput stat-dropdown`,
                    "data-dtm": "vehicle info"
                }}
                required
            >
                {sizes.map((item) => (
                    <MenuItem className="dropdown-group-element" key={item} value={item}>
                        {item}
                    </MenuItem>
                ))}
            </Select>
            {sizeError && (
                <FormHelperText error>{required}</FormHelperText>
            )}
        </FormControl>
    );

    function handleChangeMake (event) {
        dispatch(setSelectMake(event.target.value));
        setMake(event.target.value);
        setModel('');
        setTrim('');
        setSize('');
        setModelError(false);

        dispatch(setModels(clearData));
        dispatch(setTrims(clearData));
        dispatch(setSizes(clearData));
    }

    function handleCloseMake (event) {
        if (event.target.value === undefined && make === '') {
            setMakeError(false);
        } else {
            setMakeError(false);
        }
    }

    function handleChangeModel (event){
        setModel(event.target.value);
        dispatch(setSelectModel(event.target.value));

        if(model !== '' && model !== event.target.value){
            dispatch(setTrims(clearData));
            dispatch(setSizes(clearData));
        }


        setTrim('');
        setSize('');
    }

    function handleCloseModel (event){
        if (event.target.value === undefined && model === '') {
            setModelError(false);
        } else {
            setModelError(false);
        }
    }

    function handleChangeSize (event){
        setSize(event.target.value);
        dispatch(setSelectSize(event.target.value));
        if(trim === '')dispatch(setSelectTrim(null));
    }

    function handleCloseSize (event){
        if (event.target.value === undefined && size==='') {
            setSizeError( false);
        } else {
            setSizeError( false);
        }
    }

    function handleChangeTrim (event) {
        dispatch(setSelectTrim(event.target.value));
        setTrim(event.target.value);
        setSize('');
        dispatch(setSizes(clearData));
    }

    function handleChangeYear(event) {
        setYear(event.target.value);
        dispatch(setSelectYear(event.target.value));
        setMakeError(false);
        setMake('');
        setModel('');
        setTrim('');
        setSize('');

        dispatch(setMakes(clearData));
        dispatch(setModels(clearData));
        dispatch(setTrims(clearData));
        dispatch(setSizes(clearData));

    }

    function handleCloseYear (event) {
        if (event.target.value === undefined && year === '') {
            setYearError(false);
        } else {
            setYearError(false);
        }
    }

    function zipCodeValidation (event){
        if (!event.currentTarget.value.match(/^\b\d{5}(-\d{4})?\b$/)){
            setErrZip(true);
            setZipError(false);
        } else{
            setErrZip(false);
            setZipError(false);
        }
    }

    function updateSelectedZipCode (event) {
        setZip(event.target.value);
        if (event.currentTarget.value.match(/^\b\d{5}(-\d{4})?\b$/)) {
            dispatch(clearCurrentLatLng());
            dispatch(setZipCode(event.target.value));
            setErrZip(false);
            setZipError(false);
        }
    }

    function WidgetModal (){
        const [open, setOpen] = useState(false);
        const brand = useSelector(state => state.appParamsReducer.brand);
        const handleOpen = () => {
            setOpen(true);
        };

        const handleClose = () => {
            setOpen(false);
        };

        return (
            <div>
                <IconButton className={'widgetButton'} aria-label={"How to find your tire size"} onClick={handleOpen}>
                    <HelpOutlineIcon/>
                </IconButton>

                <Dialog
                    aria-labelledby="How to find tire size"
                    aria-describedby="How to find tire size"
                    open={open}
                    onClose={handleClose}
                >
                        <div className="header-close" onClick={handleClose}>
                            <div className="header-close-icon icon close" />
                        </div>
                    <div>
                        {brand==='chevy'?<img className={'helpImage'} src = {sizeImage_chevy} alt = 'How to find tire size'/>
                        :<img className={'helpImage'} src = {sizeImage} alt = 'How to find tire size'/>
                        }
                    </div>
                </Dialog>
            </div>
        );
    }

    return <>
        <div className = "widgetContainer">
            <div className="yearMakeModelDisplayWidget">
                <div className="headerWidget">FIND TIRE PRICING</div>
                <div className="widgetmini">Find pricing for tires specific to your vehicle</div>
                <div className={'miniHeaderWidget'}>
                    <Grid container spacing={1} alignItems={'flex-end'}>
                        <Grid item xs={4}>
                            <div>{yearDropdown}</div>
                        </Grid>
                        <Grid item xs={8} >
                            <div>{makeDropdown}</div>
                        </Grid>
                    </Grid>
                </div>
                <div className="miniHeaderWidget">{modelDropdown}</div>
                <div className="miniHeaderWidget">{trimDropdown}</div>
                <div className={'widgetGrid'}>
                    <Grid container spacing={1} alignItems={'center'}>
                        <Grid item xs={11}>
                            <div>{sizeDropdown}</div>
                        </Grid>
                        <Grid item xs={1} >
                            <div><WidgetModal /></div>
                        </Grid>
                    </Grid>
                </div>
                <div className="miniHeaderWidget">
                    <TextField id="inputZipCode" name="zipCodeInput" variant = "outlined" className="trim-dropdown"
                               label="Zipcode" size={'small'} margin="dense" inputProps = {{maxLength: 5 }}
                               value={zip}
                               onChange={updateSelectedZipCode}
                               onBlur={zipCodeValidation}/>
                    {errZip && (<FormHelperText error>{ZIP_ERROR}</FormHelperText>)}
                    {zipError && (<FormHelperText error>{required}</FormHelperText>)}
                </div>
                <ul>
                    <button className="button primary-button"
                            onClick={() => ValidateAndLoad('zip')}>
                        {FINDTIRES}
                    </button>
                </ul>
            </div>
        </div>

    </>
}

const mapStateToProps = (state) => {
    return {
        years: state.yearMakeModelReducer.years,
        makes: state.yearMakeModelReducer.makes,
        models: state.yearMakeModelReducer.models,
        trims: state.yearMakeModelReducer.trims,
        sizes: state.yearMakeModelReducer.sizes,
        zipCode: state.yearMakeModelReducer.zipCode,
    }
};

export default connect(mapStateToProps, {setSelectYear, setSelectMake, setSelectModel,
    setSelectTrim, setSelectSize, setZipCode})(Widget)
